import { LimitKeys } from '@griply/types';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';

const NO_OPTIONS = {};

export const useTwoWaySyncAllowed = () =>
  usePremiumFeatureAllowed(LimitKeys.TwoWayCalendarSync, NO_OPTIONS);
